export default __webpack_public_path__ + "static/media/slide2.9f37ab39.jpg";